import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Modal } from "react-bootstrap";
import Button from "../../button/Button";
import FormHeader from "../FormWidgets/FormHeader";
import NumberContiner from "../FormWidgets/NumberContainer/NumberContiner";
import FieldHeader from "../FormWidgets/FieldHeader";
import "./LearnMore.scss";

interface IProps {
    show: boolean;
    handleClose: Function;
    handleAcknowledge?: Function;
    showAcknowledge?: boolean;
}

interface InfoProps {
    step: number;
    title: string;
    description: string;
    active: boolean;
}

const LearnMoreInfo = ({ step, title, description, active }: InfoProps) => {
    return (
        <div className={`fieldHeaderWrapperDiv ${active ? "active-step" : ""}`}>
            <div className="contains-number">
                <NumberContiner name={step.toString()} />
            </div>
            <FieldHeader name={title} description={description} />
        </div>
    );
};
const LearnMore = (props: IProps) => {
    const { t } = useTranslation();
    const [activeStep, setActiveStep] = useState(1);

    useEffect(() => {
        if (!props.show) return;

        setActiveStep(1);

        const interval = setInterval(() => {
            setActiveStep((prev) => {
                if (prev === 4) {
                    setActiveStep(0);
                    clearInterval(interval);
                    return prev;
                }
                return prev + 1;
            });
        }, 5500);

        return () => clearInterval(interval);
    }, [props.show]);

    return (
        <Modal
            show={props.show}
            centered
            className="learn-more-modal"
            dialogClassName="slide-up-from-bottom"
            backdropClassName="fade-backdrop"
            onHide={() => props.handleClose()}
        >
            <div className="learn-more-wrapper">
                <FormHeader
                    handleClose={() => props.handleClose()}
                    name={t(`Eisenhower.Setup.Nodes.GettingStarted`)}
                    description={t(`Eisenhower.Setup.Nodes.GettingStartedDes`)}
                />
                <video
                    width="100%"
                    controls
                    autoPlay
                    muted
                    playsInline
                    controlsList="nodownload"
                    preload="metadata"
                    style={{ borderRadius: "8px", boxShadow: "0 4px 6px rgba(0,0,0,0.1)" }}
                >
                    <source src="/marketing-assets/edgeai-walkthrough.mp4" type="video/mp4" />
                </video>
                <div className="wrapSteps">
                    {[1, 2, 3, 4].map((step) => (
                        <LearnMoreInfo
                            key={step}
                            step={step}
                            title={t(`Eisenhower.Setup.Nodes.Step${step}`)}
                            description={t(`Eisenhower.Setup.Nodes.Step${step}Des`)}
                            active={activeStep === step}
                        />
                    ))}
                </div>
                {props.showAcknowledge && (
                    <div className="button-wrapper">
                        <Button variant="secondary" onClick={() => props.handleClose()}>
                            {t("Shared.cancel")}
                        </Button>
                        <Button
                            variant="primary"
                            disabled={false}
                            onClick={() => {
                                props.handleAcknowledge();
                            }}
                            id="save-source-button"
                        >
                            {t("Eisenhower.Setup.Nodes.Acknowledgement")}
                        </Button>
                    </div>
                )}
            </div>
        </Modal>
    );
};

export default LearnMore;
